import React from 'react'
import { STANDARD_PRICING_STARTUP } from 'services/cfg/form'
import { Create } from 'react-admin'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import PhysicalExperiencesForm from './PhysicalExperiencesForm'

// TODO check if the default can be set in the array input directly
const PhysicalExperienceCreate: React.FC = () => {
  return (
    <SectionWrapper>
      <Create record={{ pricing: STANDARD_PRICING_STARTUP }}>
        <PhysicalExperiencesForm />
      </Create>
    </SectionWrapper>
  )
}

export default PhysicalExperienceCreate
